import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

gsap.registerPlugin(ScrollTrigger)

const SELECTORS = {
  parallax: '.js-parallax',
  cards: '[data-speed]'
}

class ParallaxCards {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.cards = this.element.querySelectorAll(SELECTORS.cards)
    this.query = window.matchMedia('(min-width: 768px)')
    this.init()
  }

  init() {
    this.animation = this.triggerParallax()

    if (document.documentElement.classList.contains('reduced-motion')) {
      this.resetParallax()
    }

    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.REDUCED_MOTION_CHANGE, (motionReduced) => {
      if (motionReduced) {
        this.resetParallax()
      } else {
        this.animation.scrollTrigger.enable()
      }
    })
  }

  triggerParallax() {
    const maxDistance = 48
    return gsap.fromTo(this.cards, {
      y: (i, card) => parseFloat(card.getAttribute('data-speed')) * maxDistance
    },
    {
      y: (i, card) => parseFloat(card.getAttribute('data-speed')) * maxDistance * -1,
      ease: 'none',
      scrollTrigger: {
        trigger: this.element,
        start: 'top bottom',
        end: () => 'bottom top',
        invalidateOnRefresh: true,
        scrub: 0.5
      }
    })
  }

  resetParallax() {
    this.animation.scrollTrigger.disable(true, false)
    this.cards.forEach(card => {
      card.style.transform = 'none'
    })
  }
}

export default {
  selector: SELECTORS.parallax,
  Source: ParallaxCards
}
